import { queryKeys } from '@api/queryKeys';
import { HttpError, isUnauthorizedError } from '@api/types';
import { SessionStorageKeys } from '@commons/consts';
import { UserInfo } from '@models/userInfo';
import { useQuery } from '@tanstack/react-query';
import { usePageRefreshOnUnauthorizedError } from '@utils/hooks';
import { fetchUserInfo } from './userInfo';

export const useUserInfo = () => {
  const { refreshPage } = usePageRefreshOnUnauthorizedError();

  return useQuery<UserInfo, HttpError | Error>(
    [queryKeys.userInfo],
    fetchUserInfo,
    {
      cacheTime: Infinity,
      staleTime: Infinity,
      retry: (failureCount, error) =>
        !isUnauthorizedError(error) && failureCount < 3,
      onError: refreshPage,
      enabled: !!sessionStorage.getItem(SessionStorageKeys.token),
    },
  );
};
